import { Ng2StateDeclaration } from '@uirouter/angular';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { InvoiceRegisterContainerComponent } from './invoice-register-container/invoice-register-container.component';
const log = new LoggingService();

export const InvoiceRegisterRoute: Ng2StateDeclaration = {
    // name: 'InvoiceRegister.**'
    name: 'invoice.register',
    url: '/register',
    // , loadChildren: () => import('./invoice-register.module').then(r => r.InvoiceRegisterModule)
    data: { requiresAuth: true },

    component: InvoiceRegisterContainerComponent
};
